export const appElement = 'afResetPassword';
